import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const notification = new Vuex.Store( {
    namespaced: true,
    state: {
      notifications: [],
      unread: 0,
    },
    actions: {
      setNotification({ commit }, data) {
        /*axios.get('app/get-notifications')
        .then(function (r) {
            commit('getNotification', r.data);
        }).catch(function (e) {
            commit('getNotification');
        });*/
        commit('setNotification', data);
      },
      addNotification({ commit }, data) {
        /*axios.get('app/get-notifications')
        .then(function (r) {
            commit('getNotification', r.data);
        }).catch(function (e) {
            commit('getNotification');
        });*/
        commit('addNotification', data);
      },
    },
    mutations: {
      setNotification(state, notifications) {
        state.notifications = notifications;
        //state.unread = notifications.unread;
      },
      addNotification(state, notifications) {
        state.notifications.push(notifications);
        //state.unread = notifications.unread;
      },
    },
    getters: {
      getNotifications(state) {
        return state.notifications
      },
      getUnread(state) {
        return state.unread
      },
    },
})

export default notification



// WEBPACK FOOTER //
// ./src/notification.js